import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function SystemsInMotion() {
  const [layers, setLayers] = useState([]);

  useEffect(() => {
    api.get("/system-layers").then(({ data }) => setLayers(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="systems-in-motion-page" className="px-6 md:px-14 py-16 md:py-24">
      <div className="max-w-6xl">
        <div className="text-overline mb-4">◢ Architecture</div>
        <h1 className="font-display font-bold tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-white leading-[1]">
          Systems in <span className="text-[#FF4500]">motion</span>.
        </h1>
        <p className="mt-5 text-[#8E8E93] max-w-2xl text-[15px]">
          The Wisewit execution layer is built as a stack of focused layers — engineered so capture,
          inference, and action stay close to each other and to the floor.
        </p>
      </div>

      <div className="mt-14 max-w-5xl">
        {layers.map((l) => (
          <div
            key={l.id}
            data-testid={`layer-${l.layer_id}`}
            className="grid grid-cols-12 gap-4 py-8 border-t border-[#2A2A2A] group hover:bg-[#0a0a0a] transition-colors px-2"
          >
            <div className="col-span-2 md:col-span-1 font-mono text-[11px] tracking-[0.2em] uppercase text-[#FF4500]">
              L{l.layer_id}
            </div>
            <div className="col-span-10 md:col-span-4 font-display text-2xl text-white">{l.name}</div>
            <div className="col-span-12 md:col-span-4 text-[#8E8E93] text-sm leading-relaxed">{l.description}</div>
            <div className="col-span-12 md:col-span-3 flex flex-wrap gap-2 items-start">
              {(l.tech || []).map((t) => <span key={t} className="ww-chip text-[10px]">{t}</span>)}
            </div>
          </div>
        ))}
        <div className="border-t border-[#2A2A2A]" />
      </div>

      <div className="mt-14 max-w-5xl ww-card p-8" data-testid="philosophy-card">
        <div className="text-overline mb-3">◢ Philosophy</div>
        <p className="text-[#F5F5F5] text-lg leading-relaxed">
          We treat the plant as the runtime, not the model. Models are replaceable; the loop is not.
          Every layer has a single job, a clear interface, and a way to be measured.
        </p>
      </div>
    </div>
  );
}
